<section
  class="av-export-status av-export-status--{{ tone() }} d-flex align-items-center gap-3"
  role="status"
  aria-live="polite"
  [attr.aria-busy]="busy()"
>
  @if (busy()) {
    <av-spin size="sm" />
  } @else if (phase() === 'completed') {
    <mat-icon class="av-export-status__icon">check_circle</mat-icon>
  } @else {
    <mat-icon class="av-export-status__icon">error</mat-icon>
  }

  <div class="av-export-status__body d-flex flex-column flex-grow-1 min-width-0">
    <span class="av-export-status__message">{{ messageKey() | translate }}</span>
    @if (phase() === 'completed' && rowCount() !== null) {
      <span class="av-export-status__hint small">{{
        'app.reports.allDemands.export.rowCount' | translate: { count: rowCount() }
      }}</span>
    }
  </div>

  <div class="d-flex align-items-center gap-2 flex-shrink-0">
    @if (phase() === 'completed') {
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="downloading()"
        [avPending]="downloading()"
        (click)="download.emit()"
      >
        @if (downloading()) {
          <av-spin size="sm" />
        } @else {
          <mat-icon>download</mat-icon>
        }
        {{ 'app.reports.allDemands.export.download' | translate }}
      </button>
    }
    <button mat-button type="button" (click)="dismiss.emit()">
      {{ 'app.reports.allDemands.export.dismiss' | translate }}
    </button>
  </div>
</section>
